
import {Vue, Component} from 'vue-property-decorator';
import VTooltip from "@/components/bootstrap/vTooltip.vue";

@Component({
  components: {VTooltip}
})
export default class vTrialMasker extends Vue {
  get isTrial() {
    return this.$store.getters.getUserDetails.isTrial;
  }
}
